import { mouse } from 'd3';
import { ChartDimensions } from '../interfaces/barGraph';
import { Observable } from 'rxjs';

export class GraphEvents {
  hoverContainer: any;
  mouseMoveRef: any;

  constructor(
    private svg: any,
    private chartDimensions: ChartDimensions
  ) {
    this.hoverContainer = this.drawMouseHoverContainer();
    this.mouseMoveRef = this.appendOverlayContainer();
  }

  appendOverlayContainer() {
    return this.hoverContainer.append('rect')
      .attr('class', 'overlay')
      .attr('width', this.chartDimensions.chartWidth)
      .attr('height', this.chartDimensions.chartHeight * 1.25);
  }

  drawMouseHoverContainer() {
    return this.svg.append('g').attr('class', 'hoverContainer');
  }

  onMouseMove(): Observable<any> {
    return Observable.create((observer) => {
      this.mouseMoveRef.on('mousemove', function () {
        observer.next(mouse(this));
      });

      return () => {
        this.mouseMoveRef.on('mousemove', null);
      };
    });
  }

  onMouseLeave(): Observable<any> {
    return Observable.create((observer) => {
      this.mouseMoveRef.on('mouseleave', function () {
        observer.next(mouse(this));
      });

      return () => {
        this.mouseMoveRef.on('mouseleave', null);
      };
    });
  }
}
